import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC } from "react";
import { evaluateHideComponent } from "@Modules/eventPage/utils/render";
import { DetailsForm } from "./components/DetailsForm/DetailsForm";
import styles from "./RenewBookingForm.module.scss";
import { IRenewBookingForm } from "./IRenewBookingForm";
import useRenewBookingForm from "./utils/useRenewBookingForm";

const RenewBookingForm: FC<IRenewBookingForm.IProps> = props => {
    const { isMobile, showOn } = props;
    const {
        hideComponent,
        rebookingFormRef,
        renewBookingFormDetails,
        setRenewBookingFormDetails,
        billingStateNonMandatory,
        showGstOption,
        isGstChecked,
        handleGstCheck,
        renewBookingBaseFormFields,
        renewBookingGstFormFields,
    } = useRenewBookingForm();

    if (evaluateHideComponent({ hideComponent, isMobile, showOn })) return null;

    const commonDetailsFormProps = {
        isMobile,
        formDetails: renewBookingFormDetails,
        setFormDetails: setRenewBookingFormDetails,
        isGstChecked,
        billingStateNonMandatory,
    };

    return (
        <>
            <div ref={rebookingFormRef} />
            <DetailsForm
                formFields={renewBookingBaseFormFields}
                {...commonDetailsFormProps}
            />

            {showGstOption && (
                <>
                    <div className={styles.formField}>
                        <label
                            htmlFor="rebookingInfo-gstCheck"
                            className={classNames(
                                styles.inputContainer,
                                styles.tNc
                            )}
                        >
                            <input
                                type="checkbox"
                                name="gst"
                                id="rebookingInfo-gstCheck"
                                checked={isGstChecked}
                                onChange={handleGstCheck}
                            />
                            <span className={styles.tncLabel}>
                                I have GST number (India Only)
                            </span>
                        </label>
                    </div>
                    <hr />
                </>
            )}

            {isGstChecked && (
                <DetailsForm
                    formFields={renewBookingGstFormFields}
                    {...commonDetailsFormProps}
                />
            )}
        </>
    );
};

export default RenewBookingForm;
